// @flow

import HomeFeatures from 'models/HomeFeatures';
import RentFeeOwner from 'models/RentFeeOwner';

export default class HomeOnBoarding {
  id: string;
  currency: string;
  apartment_type: string;
  country: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  int_number: string;
  zip: string;
  antique: number;
  apartment_floor: string;
  floor: string;
  sqare_mts: number;
  bedrooms: number;
  bathrooms: number;
  parkings: number;
  photoShootingPrice: number;
  photoshooting: any;
  recommended_number_of_tenants: number;
  recommended_price: number;
  rentFeeforOwner: {
    homieFirstFee: number,
    homieMonthlyFee: number
  };
  terrace_sqare_mts: string;
  balcony_sqare_mts: string;
  garden_sqare_mts: string;
  yard_sqare_mts: string;
  name: string;
  description: string;
  youtube_link: string;
  minimal_rent_months: number;
  deposit_months_warranty: number;
  pets_deposit_percentage: number;
  price: number;
  extra_services_amount: number;
  is_rent_billable: boolean;
  isMeeroEnabled: boolean;
  available_from: string;
  available_for_meetings_from: string;
  pets_allowed: number;
  owner: {
    user: {
      name: string,
      last_name: string,
      second_last_name: string,
      email: string,
      rfc: string,
      gender: string,
      curp: string,
      mobile_phone: number,
      phone_country_code: number
    }
  };
  home_features: HomeFeatures;
  home_schedule: {
    schedule_globals: Array<{
      day: number,
      available_times: Array<number>
    }>
  };
  status: string;
  externalHomePrice: number;
  address_from_location: string;
  location: ?{
    lat: number,
    lng: number
  };
  _step: string;
  agencyId: String;
  hasExtraServicesAmount: boolean;
  bannerPhoto: ?string;
  advisorId: String;
  steps: Array<any>;
  isFromProductSeeker: boolean;
  isCandidateProduct_100_550: boolean;
  accepted_terms_and_conditions: boolean;

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.currency = data.currency;
    this.apartment_type = data.apartment_type || 'apartment';
    this.country = data.country || '';
    this.state = data.state || '';
    this.city = data.city || '';
    this.neighborhood = data.neighborhood || '';
    this.street = data.street || '';
    this.number = data.number || '';
    this.int_number = data.int_number || '';
    this.zip = data.zip || '';
    this.antique = data.antique || 0;
    this.apartment_floor = data.apartment_floor || '';
    this.floor = data.floor || '';
    this.sqare_mts = data.sqare_mts;
    this.bedrooms = data.bedrooms || 0;
    this.bathrooms = data.bathrooms || 0;
    this.parkings = data.parkings || 0;
    this.photoShootingPrice = this.currencyFormat(
      data.photo_shooting_price || 0
    );
    this.recommended_number_of_tenants =
      data.recommended_number_of_tenants || 0;
    this.recommended_price = data.recommended_price || 0;
    this.terrace_sqare_mts = data.terrace_sqare_mts || '';
    this.balcony_sqare_mts = data.balcony_sqare_mts || '';
    this.garden_sqare_mts = data.garden_sqare_mts || '';
    this.yard_sqare_mts = data.yard_sqare_mts || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.youtube_link = data.youtube_link || '';
    this.minimal_rent_months = data.minimal_rent_months || 0;
    this.deposit_months_warranty = data.deposit_months_warranty || 0;
    this.pets_deposit_percentage = data.pets_deposit_percentage || 0;
    this.price = data.price || 0;
    this.extra_services_amount = data.extra_services_amount || 0;
    this.is_rent_billable = data.is_rent_billable || false;
    this.isMeeroEnabled = data.is_meero_enabled || false;
    this.available_from = data.available_from || '';
    this.available_for_meetings_from = data.available_for_meetings_from || '';
    this.owner = data.owner;
    this.home_features = new HomeFeatures(data.home_features);
    this.home_schedule = data.home_schedule;
    this.status = data.status || '';
    this.rentFeeforOwner = new RentFeeOwner(data.rent_fee_for_owner);
    this._step = data._step || 'account';
    this.bannerPhoto = data.banner_photo;
    this.photoshooting = data.photoshooting;
    this.externalHomePrice = data.external_owner_info
      ? data.external_owner_info.price
      : 0;
    this.address_from_location = data.address_from_location || '';
    this.location =
      data.location && data.location.lat ? data.location : undefined;
    this.source = data.source;
    this.agencyId = data.agency_id;
    this.hasExtraServicesAmount = data.has_extra_services_amount;
    this.advisorId = data.advisor_id;
    this.pets_allowed = data.pets_allowed;
    this.steps = data.steps || [];
    this.isFromProductSeeker = !!data.is_from_product_seeker;
    this.isCandidateProduct_100_550 = data.is_candidate_product_100_550;
    this.accepted_terms_and_conditions = data.accepted_terms_and_conditions;
  }

  currencyFormat = value => {
    if (isNaN(value)) {
      value = 0;
    }

    value = parseFloat(value).toFixed(2);
    return '$' + value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  };

  static serializeForBackend(values: any): any {
    const getNeighborhoodId = (values: any) => {
      let neighborhood = {};
      if (values.neighborhood_id) {
        neighborhood.neighborhood_id = values.neighborhood_id;
      }
      return neighborhood;
    };

    let neighborhoodId = getNeighborhoodId(values);
    return {
      home: {
        id: values.id,
        user: values.user,
        apartment_type: values.apartment_type,
        country: values.country,
        state: values.state,
        city: values.city,
        neighborhood: values.neighborhood,
        street: values.street,
        number: values.number,
        int_number: values.int_number,
        zip: values.zip,
        antique: values.antique,
        apartment_floor: values.apartment_floor,
        floor: values.floor,
        location: values.location,
        address_from_location: values.address_from_location,
        sqare_mts: values.sqare_mts,
        bedrooms: values.bedrooms,
        bathrooms: values.bathrooms,
        parkings: values.parkings,
        recommended_number_of_tenants: values.recommended_tenants,
        name: values.name,
        description: values.description,
        youtube_link: values.youtube_link,
        accepted_terms_and_conditions: values.accepted_terms_and_conditions,
        terrace_sqare_mts: values.terrace_sqare_mts,
        balcony_sqare_mts: values.balcony_sqare_mts,
        garden_sqare_mts: values.garden_sqare_mts,
        yard_sqare_mts: values.yard_sqare_mts,
        minimal_rent_months: values.minimal_rent_months,
        deposit_months_warranty: values.deposit_months_warranty,
        pets_deposit_percentage: values.pets_deposit_percentage,
        price: values.price,
        extra_services_amount: values.extra_services_amount,
        is_rent_billable: values.is_rent_billable,
        home_feature: values.home_feature,
        available_from: values.available_from,
        available_for_meetings_from: values.available_meetings_from,
        home_schedule: values.schedule_global,
        owner: values.owner,
        status: values.status,
        _step: values._step,
        agencyId: values.agencyId,
        ...neighborhoodId,
        has_extra_services_amount: values.hasExtraServicesAmount,
        advisorId: values.advisorId,
        pets_allowed: values.pets_allowed
      },
      sub_step: values.sub_step
    };
  }

  static serializedHomeSchedule(appointmentTimes) {
    let scheduleGlobals = [];
    const isFullWeek = appointmentTimesArr => {
      return appointmentTimesArr.length === 7;
    };
    delete appointmentTimes.id;
    const appointmentTimesArr = Object.entries(appointmentTimes);
    if (isFullWeek(appointmentTimesArr))
      appointmentTimesArr.splice(0, 0, appointmentTimesArr.pop());
    appointmentTimesArr.forEach(([key, value], index) => {
      scheduleGlobals.push({
        day: index,
        available_times: value
      });
    });
    return scheduleGlobals;
  }
}
